/**
 * @file Contains helper functions for AssignmentSelected component
 */
import userGetName from '../../../../../utils/user/userGetName';

import {
  SearchData,
  SearchDataItem,
  SearchDataUpdater,
  SelectedItem,
} from '../types';

/**
 * Get label for selected item
 *
 * @param data Selected item
 *
 * @returns    Label for selected item
 */
export const getSelectedItemLabel = (data: SearchDataItem): string => {
  if ('title' in data) {
    return data.title;
  }
  if ('text' in data) {
    return data.text;
  }
  return userGetName(data);
};

/**
 * Get serialized items
 *
 * @param data     Selected items
 * @param updater  Updater function used to remove item
 * @param withIcon Whether to display icon in chip
 *
 * @returns        Array of items that will be displayed as chips
 */
export const getSelectedItems = (
  data: SearchData,
  updater: SearchDataUpdater,
  withIcon = false,
): SelectedItem[] =>
  data.map(item => ({
    label: getSelectedItemLabel(item),
    /**
     * Remove the item from the list
     */
    onDelete: () => {
      updater(item.id, false);
    },
    shouldShowIcon: withIcon,
  }));
